import { useEffect, useState } from "react";
import {
  ParsersPanel,
  RunNode,
  RunStatsResponse,
} from "../../../api/ParsersPanel";
import { useUserState } from "../../../store/user/hooks";

interface State {
  data: RunStatsResponse | null;
  loading: boolean;
  error: string | null;
}

export function useRunStats(
  node: RunNode,
  hours = 48,
): State {
  const { token } = useUserState();

  const [state, setState] = useState<State>({
    data: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!token) return;

    setState((s) => ({
      ...s,
      loading: true,
      error: null,
    }));

    ParsersPanel.getRunStats(token, node, hours)
      .then((data) =>
        setState({
          data,
          loading: false,
          error: null,
        })
      )
      .catch((err) => {
        const msg =
          err?.response?.data?.error ||
          err?.message ||
          "Failed to load run stats";

        setState({
          data: null,
          loading: false,
          error: msg,
        });
      });
  }, [token, node, hours]);

  return state;
}